import React from 'react';
import contact from '../assets/images/contact.jpg';
import useContactForm from './hooks/useContactForm';

const Contact = () => {
    const { formData, handleChange, handleSubmit, isSuccess, isError, isSuccessMessage, errorMessage } = useContactForm()

    return (
        <>
            <div className="bg contact-bg1">
                <h1>Contact Us</h1>
            </div>
            <section className="pb-24 pt-20">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-x-24">
                        <div className="flex items-center lg:mb-0 mb-10">
                            <div className="">
                                <h2 className="text-gray-900 font-manrope text-4xl font-semibold leading-10 mb-9 lg:text-left text-center">Reach Out To Us</h2>
                                {isError && <p className='text-red-800'>{errorMessage}</p>}
                                {isSuccess && <p className='text-blue-700'>{isSuccessMessage}</p>}
                                <p className="text-gray-600 text-base font-normal leading-6 mb-8 lg:text-left text-center">We are here to help you with your digital marketing needs. Fill out the form below and our team will get back to you shortly.</p>
                                <form method="post" onSubmit={handleSubmit}>
                                    <input type="text" name='name' className="inputContact" placeholder="Name" value={formData.name} onChange={handleChange} />
                                    <input type="email" name='email' className="inputContact" placeholder="Email" value={formData.email} onChange={handleChange} />
                                    <input type="number" name="mobileNumber" value={formData.mobileNumber} placeholder="Phone Number*" onChange={handleChange} className='inputContact'/>
                                    <select name="service" className='inputContact' value={formData.service} onChange={handleChange}>
                                        <option value="">Select Service*</option>
                                        <option value="Website Development">Website Design and Development</option>
                                        <option value="Social Media Management">Social Media Management</option>
                                        <option value="Facebook Ads">Facebook Ads</option>
                                        <option value="Google Ads">Google Ads</option>
                                        <option value="WhatsApp API Automation">WhatsApp API Automation</option>
                                        <option value="Other">Others</option>
                                    </select>
                                    <textarea name='message' className="inputContact" placeholder="Message" value={formData.message} onChange={handleChange}></textarea>
                                    <button className="w-full h-12 text-center bg-black text-white font-bold py-2 px-4 rounded-full">Submit</button>
                                </form>
                            </div>
                        </div>

                        {/* Image Section */}
                        <div className="relative lg:max-w-xl w-full h-[350px] lg:h-[600px] rounded-xl overflow-hidden shadow-lg">
                            <div className="absolute inset-0 bg-cover bg-center contact-bg" />
                            {/* Example image */}
                            <img
                                src={contact} 
                                alt="Contact us"
                                className="object-cover w-full h-full opacity-30"
                            />
                            </div>
                        </div>

                        </div>
            </section>
        </>
    )
}

export default Contact